import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { Editor } from 'slate';
import { ReactEditor, RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_OUTLINE_STATEMENT, OutlineStatementPluginOptions } from './OutlineStatementPlugin.types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const OutlineStatement = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() =>
  import('./components/OutlineStatement').then((mod) => mod.OutlineStatement),
));

export const OutlineStatementPlugin = (
  options: OutlineStatementPluginOptions = {},
): SlatePlugin => {
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      if (element?.type === ELEMENT_OUTLINE_STATEMENT) {
        return <OutlineStatement {...renderProps} {...options} />;
      }

      return undefined;
    },
  };
};

export const withSingleOutlineStatementNode =
  () =>
  <T extends ReactEditor>(editor: T) => {
    const { insertBreak } = editor;

    editor.insertBreak = () => {
      const { selection } = editor;

      if (selection) {
        const [foundNode] = Editor.nodes(editor, {
          at: editor.selection,
          match: (n: any) => [ELEMENT_OUTLINE_STATEMENT].includes(n?.type as string),
        });

        if (foundNode) {
          editor.insertText('\n');
          return;
        }
      }
      insertBreak();
    };

    return editor;
  };
